export default {
    install: (app, options) => {
        app.config.globalProperties.$gate = options.gate;
        app.config.globalProperties.$can = null; // Todo
        app.config.globalProperties.$cannot = null; // Todo
    }
}